<template>
  <div>
    <h2 class="text-center">Tags List</h2>
    <router-link
      class="btn-primary bg-green border-none inline-block leading-snug px-4 py-2 text-white my-2 hover:bg-green-900 rounded-full no-underline"
      to="/tag-add"
    >
      New Tag
    </router-link>
    <Table ref="myTable" :endpoint="endpoint" :tableConfig="tableConfig" />
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"
import Table from "@/components/DataTable/Table"

export default {
  components: { Table },
  data() {
    return {
      endpoint: `${siteConfig.siteURL}qtags/`,
      tableConfig: [
        {
          header: { textContent: "Name", sortingParam: "name" },
          path: "name",
        },
        {
          header: { textContent: "Id" },
          path: "id",
        },
        {
          header: { textContent: "Created On", sortingParam: "created_on" },
          type: "date",
          path: "created_on",
        },
        {
          header: { textContent: "Updated On", sortingParam: "updated_on" },
          type: "date",
          path: "updated_on",
        },
        {
          header: { textContent: "Q. Count" },
          path: "questions.length",
        },
        {
          header: { textContent: "Option" },
          routePath: "/tag-edit/:id",
          type: "action",
          actionButtonText: "Edit",
          path: "id",
        },
      ],
    }
  },
}
</script>
